// Shapes shared by the API and the web for the business-first front end (Today, areas, Ask LEO).
export interface Basis { source: string; asOf: string }
export interface OpenLink { to: string; filters?: Record<string, string> }

export interface TileData { label: string; value: string; sub?: string; to: string; tone?: 'good' | 'needs' | 'under' | 'neutral' }

export interface TodayItem {
  id: string; headline: string; why: string;
  ask: { kind: 'decision' | 'info'; recommendationId?: number };
  basis: Basis[]; open: OpenLink; amount: number | null; severity: 'S1' | 'S2' | 'S3';
}
export interface TodayResponse { ready: boolean; asOf: string | null; items: TodayItem[]; tiles: TileData[]; message?: string }

export type AreaId = 'sales' | 'stock' | 'finance' | 'buying' | 'plan' | 'decisions';
export const AREAS: AreaId[] = ['sales', 'stock', 'finance', 'buying', 'plan', 'decisions'];
export interface AreaStatus {
  state: 'ready' | 'waiting' | 'partial'; tone?: 'good' | 'needs' | 'under' | 'neutral'; sentence: string; basis: Basis[]; tiles: TileData[];
  unlocks?: string[]; alreadyKnown?: { label: string; value: string }[];
}

export interface AskAnswer {
  ok: boolean; prose: string | null;
  table?: { columns: string[]; rows: (string | number | null)[][] };
  basis: Basis[]; open?: OpenLink; followUps: string[];
  unavailable?: { missing: string; unlocks: string };
}
export interface AskChip { id: string; text: string }

/** Old routes → new ones. Used by the web router and by the Today composer when it turns engine links into open links. */
export const REDIRECTS: Record<string, string> = {
  '/command': '/group', '/inventory/cover': '/stock', '/inventory': '/stock', '/decisions': '/decisions', '/plan': '/plan', '/sales': '/sales',
  '/data': '/settings/data-quality', '/data/issues': '/settings/data-quality/findings', '/data/families': '/settings/mappings', '/data/organisation': '/settings/group-structure',
  '/data/hub': '/settings/data-loads', '/data/audit': '/settings/audit', '/finance/margins': '/settings/brand-terms',
  // the old briefing page and the master-inventory page that no menu reached (gap analysis, Nov 2026)
  '/today': '/group', '/settings/inventory': '/stock/valuation',
};
export const redirectOf = (path: string): string => {
  const [p, q] = path.split('?');
  for (const [from, to] of Object.entries(REDIRECTS).sort((a, b) => b[0].length - a[0].length)) if (p === from || p!.startsWith(from + '/')) return to + p!.slice(from.length) + (q ? `?${q}` : '');
  return path;
};
